var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldBeVisible)?_c('wizard',{staticClass:"onboarding",attrs:{"steps":_vm.wizardSteps,"fullscreenOnMobile":""},on:{"close":_vm.finishOnboarding}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }